import styled from "styled-components";

export const Container = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 100px;
  overflow-y: scroll;
  .no-result {
    display: flex;
    flex: 1;
    justify-content: center;
    align-items: center;
  }
  h2 {
    font-size: 0.875rem;
    font-weight: 700;
    padding-bottom: 20px;
  }
  .main {
    display: flex;
    flex-direction: column;
    gap: 10px;
    .item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 15px;
      .left {
      }
      .right {
        font-weight: 700;
      }
    }
  }
`;
